<template>
  <div>
    <v-spacer />
      <v-btn class="mt-4" @click.native="printOverallExpense">
        <v-icon>print</v-icon>
      </v-btn>
      <v-switch
          v-model="hideZero"
          inset
          class="mb-2"
          label="Major Expenses"
        />
        <v-spacer/>
    <v-data-table :items="list" class="elevation-1 black--text font-weight-bold"  :headers="headers">
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item['.key'] }}</td> -->
        <!-- <td>{{ props.item.firm }}</td> -->
        <td><b class="primary--text font-weight-bolder">{{ props.item.expense }} </b></td>
        <td>{{ props.item.category}}</td>
        <td>{{ props.item.underHead }}</td>
        <!-- <td>{{ props.item.totalAmount || 0 | amount }}</td> -->
        <td>{{ props.item.openingBalance | amount }}</td>
        <td>{{ props.item.taxableAmount ? props.item.taxableAmount : 0 }}</td>
        <td>{{ props.item.totalAmount | amount }}</td>
        <td>{{ ((props.item.openingBalance ? Number.parseFloat(props.item.openingBalance) : 0 ) + (props.item.totalAmount ? Number.parseFloat(props.item.totalAmount) : 0)) | amount }}</td>
        <td>{{ props.item.paymentTypeStatus }}</td>
        <td><v-btn icon round class="primary--text" @click="openExpenseDialog(props.item)">
          <v-icon dark>
            remove_red_eye
          </v-icon>
        </v-btn>
        </td>
        <td><v-btn icon round class="primary--text" @click="openExpenseEdit(props.item)">
          <v-icon dark> 
            edit 
          </v-icon>
        </v-btn></td>
        <!-- <td>{{ props.item.depriciation ? `${props.item.depriciation}%` : '--' }}</td> -->
        <!-- { text: 'Opening WDV', value: 'openingBalance', sortable: false}, -->
        <!-- { text: 'Addition', value: 'additionAmount', sortable: false}, -->
        <!-- { text: 'Deletion', value: 'deletionAmount', sortable: false}, -->
        <!-- <td>{{ props.item.totalDeletionAmount | amount }}</td> -->
        <!-- { text: 'Total', value: 'totalAmount', sortable: false}, -->
        <!-- { text: 'Dep Amount (Business)', sortable: false}, -->
        <!-- <td>{{ getDepAmount(props.item, props.item.category) | amount }}</td> -->
        <!-- { text: 'Closing WDV', sortable: false} -->
      </template>
      <template slot="no-data">No expenses to Show</template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ selectedExpense }}</v-toolbar-title>
        <v-spacer/>
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        
      </v-toolbar>
      <v-data-table :items="selectedExpenses" class="elevation-1 black--text font-weight-bold"  :headers="expenseHeader">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item['.key'] }}</td> -->
          <td><b class="font-weight-bold">{{ getFirmName(props.item.firm) }}  - {{ props.item.taxableGST_rate }} - {{ props.item.GST_type }} </b></td>
          <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>
          <td>{{ props.item.openingBalance || 0 | amount }}</td>
          <td>{{ props.item.taxableAmount || 0 | amount }}</td> 
          <td><b class="error--text font-weight-bold">{{ props.item.totalAmount || 0 | amount }}</b></td>
          <td>{{ getTotalAmount(props.item)|| 0 | amount }}</td>
          <td>{{ ((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0| amount }}</td>
          <td>{{ props.item.paymentType }}</td>
          <td>{{ props.item.remark}}</td>
          <td><v-btn v-if=" props.item.paymentTypeStatus == 'yet to confirm'" @click="openExpenseInvoiceEdit(props.item,true)">{{ props.item.paymentTypeStatus }}</v-btn>
              <b v-else>{{ props.item.paymentTypeStatus }}</b>
          </td>
          <td>
            <v-btn icon class="primary--text" @click="openExpenseInvoiceEdit(props.item,false)">
              <v-icon dark>
                edit
              </v-icon>  
            </v-btn>
          </td>
          <td>
            <v-btn icon class="red--text" @click="openExpenseInvoiceDelete(props.item)">
              <v-icon dark>
                delete
              </v-icon>  
            </v-btn>
          </td>
        </template>
        <template slot="no-data">no record found</template>
      </v-data-table>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="selectedExpense">{{ selectedExpense.expense }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEdit = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <v-card tile v-if="selectedExpense" >
          <v-card-text>
            <v-text-field 
                label="Name" 
                v-model="selectedExpense.expense">
            </v-text-field>
          <v-select
                v-bind:items="categotyList"
                v-model="selectedExpense.category" 
                label="Expense Category"
            />
            <v-select 
                v-bind:items="underHeadList"
                v-model="selectedExpense.underHead" 
                label="UnderHead"
            />
             <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveExpense()">Save</v-btn>
          </v-card-actions>
            </v-card-text>
          </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditInvoice" persistent transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="isConfirm">Confirm Expense</v-toolbar-title>
         <v-toolbar-title v-else>Edit Expense</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEditInvoice = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <v-card tile v-if="selectedExpenseInvoice" >
          <v-card-text>
              <v-radio-group v-model="selectedExpenseInvoice.paymentType" row>
                  <v-radio label="From Cash" value="cash"></v-radio>
                  <v-radio label="From Bank Account" value="account"></v-radio>
              </v-radio-group>
              <v-menu
                v-model="datepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
                <v-text-field
                  slot="activator"
                  v-model="selectedExpenseInvoice.date"
                  label="Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker 
                  v-model="selectedExpenseInvoice.date"
                  @input="datepicker = false"
                />
            </v-menu>
             <v-select
              class="select-firm"
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedExpenseInvoice.firm"
            ></v-select>
              <v-select 
            v-if="selectedExpenseInvoice.paymentType == 'account'" 
                v-model="selectAccountFromExpense"
                :items="banksByFirm"
                label="From Account"
                :disabled="!selectedExpenseInvoice.firm"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.accountnumber }}{{data.item.bankName ? ' | '+data.item.bankName : '' }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.accountnumber}
                            ${data.item.bankName ? ' | '+data.item.bankName : '' }
                            ${data.item.accountType ? ' | '+data.item.accountType : '' }`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
             <v-text-field
                type="number"
                v-model="selectedExpenseInvoice.openingBalance"
                label="Opening Balance"
              ></v-text-field>
              <v-text-field
                :value="selectedExpense"
                label="Expense"
                v-if="isConfirm"
                :disabled="true"
              ></v-text-field>
              <v-text-field
                type="number"
                v-model="selectedExpenseInvoice.totalAmount"
                label="Amount"
              ></v-text-field>
            
               <v-text-field
                v-model="selectedExpenseInvoice.remark"
                label="Remark"
              ></v-text-field>
             <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveExpenseInvoice()"><span v-if="isConfirm">Confirm</span><span v-else>Save</span></v-btn>
          </v-card-actions>
            </v-card-text>
          </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { expenseOverallReport } from "../../../utils/pdf-reports/expenseOverallReport.js";

export default {
  name: "ExpenseTableInfo",
  props: {
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
    },
  created() {
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear"]),
        banksByFirm(){
        return this.banks.filter((item) =>
        item['brand'] === this.selectedBrand 
          && item['firm'] == this.selectedExpenseInvoice.firm
        )
    },
    list() {
        let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand);
        expenses = expenses.filter(expense => !!expense['.key']);
        expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let taxableAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key']
          && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            taxableAmount += Number.parseFloat(inv.taxableAmount)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].taxableAmount = isNaN(taxableAmount) ? 0 :   Number.parseFloat(taxableAmount).toFixed(2);
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :   Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
        })
      return expenses.filter((e) => {
        if (this.hideZero) {
          return parseFloat(e.totalAmount) > 0 || parseFloat(e.openingBalance) > 0;
        }
        return true;
      });
    },
  },
  data() {
    return {
      selectedExpense : [],
      selectedExpenseInvoice : {},
      selectAccountFromExpense:null,
      isConfirm : false,
      datepicker : false,
      headers: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Name", value: "expense", sortable: true },
        { text: "Category", value: "category", sortable: true },
        { text: "Underhead", value: "underHead", sortable: false },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Amount", value: "taxableAmount", sortable: false },
        { text: "Amount", value: "totalAmount", sortable: false },
        { text: "Closing WDV", sortable: false },
        { text: "Status", value: "paymentTypeStatus", sortable: false },
        { text: "Action", sortable: false },
        { text: "Edit", sortable: false },
        // { text: "Addition", value: "additionAmount", sortable: false },
        // { text: "Deletion", value: "deletionAmount", sortable: false },
        // { text: "Dep Amount", sortable: false },
      ],
      expenseHeader: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Firm Name", value: "firm", sortable: true },
        { text: "Date", value: "expense", sortable: true },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Basic Amount", value: "taxableAmount", sortable: false },
        { text: "Amount", value: "totalAmount", sortable: false },
        { text: "Closing WDV", sortable: false },
        { text: "Payment Type", value: ".key", sortable: false },
        { text: "Remark", value: "type", sortable: true },
        { text: "Status", value: "paymentTypeStatus", sortable: false },
        { text: "Edit", sortable: false },
        { text: "Delete", sortable: false },
      ],
      dialog : false,
      dialogEdit : false,
      dialogEditInvoice: false,
      categotyList: ['Direct', 'Indirect'],
      underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
      selectedExpenses :[],
      hideZero: false,
    };
  },
  methods: {
    // getDepAmount(expense, type) {
    //   let depriciation = null;
    //   if (expense.isVerified && expense.depriciation) {
    //     const totalAmount = this.getTotalAmount(expense);
    //     depriciation = Number((totalAmount * expense.depriciation) / 100);
    //     return depriciation;
    //   }
    //   return 0;
    // },
    async printOverallExpense(expense){
      let firm  =this.firms.filter(item => item['.key'] === expense['firm'])[0];
      await expenseOverallReport({
        // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
        firm : this.firm,        
        list : this.list,
      }).then((doc) => {
        pdfMake.createPdf(doc).download('EXPENSE_REPORT_' + new Date ().toLocaleDateString('en-GB'));
      });
    },
    getTotalAmount(expense) {
        return (
          Number(expense.totalamount)
        );
    },
    getClosingWdv(expense) {
      return (
        this.getTotalAmount(expense)
      );
    },
    saveExpense() {
      let key = this.selectedExpense['.key'];
      delete  this.selectedExpense['.key'];
      this.$root.$firebaseRefs.expenses.child(key).update(this.selectedExpense).then((snap) => {
        this.dialogEdit = false;
      });
    },
    saveExpenseInvoice(){
      this.selectedExpenseInvoice.date = new Date(this.selectedExpenseInvoice.date).getTime()
          if(this.selectedExpenseInvoice.paymentType == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedExpenseInvoice.firm).once('value').then((snap) => {
                  if(Number(snap.val().amount) >= this.selectedExpenseInvoice.totalAmount){
                      this.$root.$firebaseRefs.firm.child(this.selectedExpenseInvoice.firm).update({
                          amount: Number(snap.val().amount) - Number(this.selectedExpenseInvoice.totalAmount)
                      });
                      setTimeout(() => {
                        let key = this.selectedExpenseInvoice['.key'];
                        delete this.selectedExpenseInvoice['.key'];
                        if(this.isConfirm) {
                          this.selectedExpenseInvoice['paymentTypeStatus'] = 'confirm';
                        }
                        
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedExpenseInvoice, ()=>{
                          if(this.isConfirm) {
                          this.selectedExpenseInvoice.isCredited = true;
                          this.$root.$firebaseRefs.provisionExpense.push(this.selectedExpenseInvoice)
                          }
                          this.dialogEditInvoice = false;
                        })
                        
                      })
                  } else{
                      console.log('Insufficient Balance')
                      
                  }
              })
          } else if(this.selectedExpenseInvoice.paymentType == 'account') {
              let expenseAccountFirm= null;
              let expenseAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense['.key']).once('value').then(snap => {
                  this.selectedExpenseInvoice['accountNumber'] =  snap.val().accountnumber;
                  this.selectedExpenseInvoice['bank'] =  this.selectAccountFromExpense['.key'];
                  if(Number(snap.val().amount) >= this.selectedExpenseInvoice.totalAmount){
                      this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense['.key']).update({
                          amount: Number(snap.val().amount) - Number(this.selectedExpenseInvoice.totalAmount)
                      });
                      console.log( "expense amount paid");
                       setTimeout(() => {
                        let key = this.selectedExpenseInvoice['.key'];
                        delete this.selectedExpenseInvoice['.key'] 
                         if(this.isConfirm) {
                          this.selectedExpenseInvoice['paymentTypeStatus'] = 'confirm';
                         }
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedExpenseInvoice, ()=>{
                          if(this.isConfirm) {
                            this.selectedExpenseInvoice.isCredited = true;
                            this.$root.$firebaseRefs.provisionExpense.push(this.selectedExpenseInvoice)
                          }
                          this.dialogEditInvoice = false;
                        })
                      })
                  } else{
                      console.log('Insufficient Balance');
                  }
              })
          } else {
            let key = this.selectedExpenseInvoice['.key'];
            delete this.selectedExpenseInvoice['.key'] 
            this.$root.$firebaseRefs.invoice.child(key).update(this.selectedExpenseInvoice).then((snap) => {
                this.selectedExpenseInvoice['.key'] = key;
                this.dialogEditInvoice = false;
            });
          }
    },
    openExpenseDialog(expense) {
      if(expense) {
          let invoice = this.invoices.filter(invoice => {
          return (
            invoice.brand === this.selectedBrand &&
            invoice.transactionType === "Expense" &&
            invoice.expenseType == expense[".key"] && 
           (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end)
          );
        });
        invoice.sort(function(a,b){
          return -(new Date(b.date) - new Date(a.date));
        });
        this.selectedExpenses = invoice;
        this.selectedExpense = expense["expense"];
        this.dialog = true;
      }
    },
    openExpenseEdit(expense) {
      this.selectedExpense = expense
      this.dialogEdit = true;
    },
    openExpenseInvoiceEdit(invoice,confirmDialog) {
      this.selectedExpenseInvoice = invoice;
      this.selectedExpenseInvoice.date = new Date(this.selectedExpenseInvoice.date).toISOString("en-GB").substr(0, 10)
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    },
    openExpenseInvoiceDelete(selectedExpenseInvoice) {
      if (window.confirm("Do you want to delete expense created on "  + new Date (selectedExpenseInvoice['date']).toLocaleDateString('en-GB') + "?")) {
        this.$root.$firebaseRefs.invoice.child(selectedExpenseInvoice[".key"]).remove();
      }
      this.dialog = false;
    },
    getFirmName(e){
      let firm;
      if (this.firms && this.selectedBrand) {
        firm =this.firms.filter(item => item['.key'] === e)[0]
      }
      if(firm)
      return firm.name
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/InvoiceManagement/table/expenseTable.vue